export const hasErrors = (data: importData[]): boolean => {
    for (const rowData of data) {
        if (rowData.ErrorCount > 0) {
            return true
        }
    }
    return false
}